import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import DesktopTable from "components/Common/DesktopTable";
import MobileTable from "components/Common/MobileTable";
import { http } from "middleware/apiMiddleware";
import { topUpHistory } from "constants/apiUrls";
import { useAppDispatch, useAppSelector } from "hooks/useRedux";
import { RootState } from "store";
import { settopUpHistory } from "store/slices/topUpHistorySlice";
import { useNavigate } from "react-router-dom";
import GoBack from "components/Common/GoBack";

const TABLE_HEAD = [
  "Transaction ID",
  "Amount",
  "Date",
  "Transaction type",
  "Status",
];

const TopupHistory = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const businessState = useAppSelector((state: RootState) => state.businesses);
  const topUpHistoryState = useAppSelector(
    (state: RootState) => state?.topUpHistory?.topUpHistory
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [hasMoreData, sethasMoreData] = useState<boolean>(true);
  const [busienssUuid, setbusienssUuid] = useState<string | null>(null);
  const [dataLength, setdataLength] = useState<number>(0);
  const [limit] = useState<number>(20);
  const [offSet, setoffSet] = useState<number>(0);

  const business = businessState?.business || null;

  const getHistory = useCallback(
    async (busienssUuid: string) => {
      try {
        setLoading(true);
        const { data, error } = await http.get(
          topUpHistory(busienssUuid, limit, offSet),
          undefined,
          true
        );

        if (!!data && !error) {
          setdataLength(data?.count);
          let createdData = data?.results?.map((item: any) => {
            return {
              transactionID: item?.transactionId,
              amount: item?.amount,
              date: moment(item?.transactionDate).format("MMM DD, YYYY"),
              type: item?.type,
              status: item?.transactionStatus,
            };
          });
          if (offSet > 0) {
            dispatch(settopUpHistory([...topUpHistoryState, ...createdData]));
          } else {
            dispatch(settopUpHistory([...createdData]));
          }

          setoffSet((prev) => prev + limit);
          if (data?.next) {
            sethasMoreData(true);
          } else {
            sethasMoreData(false);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    },
    [business?.uuid, limit, offSet]
  );

  useEffect(() => {
    if (business && business?.uuid) {
      setbusienssUuid(business?.uuid);
    }
  }, [business]);

  useEffect(() => {
    if (busienssUuid) {
      getHistory(busienssUuid);
    }
  }, [busienssUuid]);

  return (
    <div
      className={`bg-offWhite  p-4 mx-auto flex-col flex gap-8 h-screen md:w-[65vw] `}
    >
      {" "}
      {/* //TOP HEADER/// */}
      <div className="flex flex-row items-center my-2 md:my-5">
        <GoBack label="Transaction History" containerClass="!my-0 text-xl" />
      </div>
      <div className="md:block hidden ">
        <DesktopTable
          historyDetailsList={topUpHistoryState}
          headerList={TABLE_HEAD}
          loading={loading}
          fetchData={getHistory}
          hasMoreData={hasMoreData}
          businessID={business ? business.uuid : ""}
        />
      </div>
      <div className="md:hidden">
        <MobileTable
          historyDetailsList={topUpHistoryState}
          headerList={TABLE_HEAD}
          loading={loading}
          fetchData={getHistory}
          hasMoreData={hasMoreData}
          businessID={business ? business.uuid : ""}
        />
      </div>
    </div>
  );
};

export default TopupHistory;
